import type { Settlement } from "./settlement";

const legacyServiceFeeIncludedCheck = (settlement: Settlement): boolean => {
    const legacyServiceFeeIncluded =
        // Handle legacy service fee when settlement is for an order created event,
        // orderGroupHasLegacyServiceFee is true and the settlement is not a partial refund.
        // We don't care about legacy fees for order changes since we disabled them all
        // before releasing order change feature.
        settlement.originEvent.type === "CREATED" &&
        settlement.originEvent.orderGroupHasLegacyServiceFee &&
        // never care about legacy fees for partial refunds
        // legacy fees in the amount included when doing partial refunds
        !(
            settlement.type === "REFUND" &&
            settlement.refundRequestedEvent.type === "PARTIAL_REFUND_REQUESTED"
        );

    return legacyServiceFeeIncluded;
};

export { legacyServiceFeeIncludedCheck };
